/* eslint-disable */
import axios from 'axios'

/**
 * 定义请求常量
 * TIME_OUT、ERR_OK
 */
export const TIME_OUT = 88888888; // 请求超时时间
export const ERR_OK = '0'; // 请求成功返回状态，字段和后台统一
export const ERR_RELOGIN = 401; //重新登录状态
export const BASE_URL = process.env.BASE_URL // 引入全局url，定义在全局变量process.env中，值为空字符串
export const HOST_URL = process.env.HOST_URL // 引入全局url，定义在全局变量process.env中，值为空字符串
export const token = localStorage.getItem("token")
// 请求超时时间
import { Toast } from 'vant';
// 封装请求拦截
axios.interceptors.request.use(
	config => {
		config.headers['Content-Type'] = 'application/json;charset=UTF-8'
		return config
	},
	error => {
		return Promise.reject(error)
	}
)
// 封装响应拦截，判断token是否过期
axios.interceptors.response.use(
	response => {
		//拦截器状态
		if(response.data.code == '90007') {
			localStorage.setItem("token", '');
			localStorage.setItem("name", '');
			localStorage.setItem("userId", '');
			localStorage.setItem("schoolName", '');
			localStorage.setItem("headPhotoUrl", '');
			const local = window.location.href;
			window.location.href =
				"https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx29b2bf8c2c033c0d&redirect_uri="+ encodeURIComponent(local) +
				"&response_type=code&scope=snsapi_userinfo&state=1&connect_redirect=1#wechat_redirect"
			return false
		}else if(response.data.code == '0'||response.data.code == '200'||response.data.code == '201'||response.data.code == '1000068'){
			Interceptor(response.data.code)
			return response;
		}else{
			Toast(response.data.msg)
			return false
		}
	},
	error => {
		Toast(error.response.data)
		return false
		// if(error.response) {
		// 	//拦截器状态
		// 	Interceptor(error.response.status)
		// }
		// // 返回接口返回的错误信息
		// return Promise.reject(error.response.data)
	});

//拦截器状态
function Interceptor(i) {
	switch(i) {
		case 401:
			localStorage.clear()
			location.href = '/'
			break
	}
}

export default axios

// 封装post请求(requestUrl：域名公共部分,params：参数列表type:token类型ctype:上传数据格式类型)
export function POST(requestUrl, params = '', post, type, ctype) {
	//请求方式
	let method = post ? post : 'post'

	//默认登录token
	let token = window.localStorage.getItem('token')

	//token类型
	switch(type) {
		case 1: //注册token
			token = window.localStorage.getItem('regtoken')
			break
	}
	token = token != null ? token : ''

	//post请求
	if(method == 'post') {
		//设置Content-Type
		if(ctype == 1) {
			return axios({
				url: requestUrl,
				method: method,
				data: params,
				headers: {
					'token': token,
					'Content-Type': ctype,
					'appCode': ' AHSY   ',
					'Client':'PUB'
				}
			})
		} else if(ctype == 2) {
			return axios({
				url: requestUrl,
				method: method,
				params: params,
				headers: {
					'token': token,
					'appCode': ' AHSY   ',
					'Client':'PUB'
				}
			})
		}else if(ctype == 4) {
			return axios({
				url: requestUrl,
				method: method,
				params: params,
				headers: {
					'token': token,
					'Content-Type': 'multipart/form-data',
					'appCode': ' AHSY   ',
					'Client':'PUB'
				}
			})
		}else if(ctype == 5) {
			return axios({
				url: requestUrl,
				method: method,
				params: params,
				headers: {
					'token': token,
					'Content-Type': 'application/json',
					'appCode': ' AHSY   ',
					'Client':'PUB'
				}
			})
		}else if(ctype == 3) {
			return axios({
				url: requestUrl,
				method: method,
				params: params,
				responseType: 'blob',
				headers: {
					'token': token,
					'appCode': ' AHSY   ',
					'Client':'PUB'
				}
			})
		} else {
			return axios({
				url: requestUrl,
				method: method,
				data: params,
				headers: {
					'token': token,
					'appCode': ' AHSY   ',
					'Client':'PUB'
				}
			})
		}

	} else {
		//get请求
		return axios({
			url: requestUrl,
			method: method,
			params: params,
			headers: {
				'token': token,
				'appCode': ' AHSY   ',
				'Client':'PUB'
			}
		})
	}
}


// WEBPACK FOOTER //
// ./src/api/index.js